module.exports = __webpack_public_path__ + "static/media/3DPPA36.f2ecb676.jpg";